// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 347 ? "SVG" : chunkId) + "." + {"69":"5c1f1a57","236":"79fb42b2","311":"9008cab8","347":"22663dfd","389":"9463d7b3","498":"a163515c","520":"5fd1309e","744":"4c42792f","862":"08f97741"}[chunkId] + ".chunk.js";
};